import { Label } from 'components/ui/label';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from 'components/ui/select';
import React from 'react';
import { Control, Controller, FieldValues } from 'react-hook-form';
import { PAYMENT_CONFIG } from 'state/paymentConfig/type';

interface Iprops {
  config: PAYMENT_CONFIG.IProcessorConfiguration;
  control: Control<FieldValues, any>;
}
const ConfigSelect = ({ config, control }: Iprops) => {
  return (
    <>
      <div className="mb-3 mr-3">
        <Label htmlFor={config.code} className="text-sm font-medium text-gray-blue-80 mb-1">
          {config.displayName}
        </Label>
        <Controller
          name={config.code}
          control={control}
          rules={{ required: config.isRequired }}
          render={({ field }) => (
            <Select
              onValueChange={field.onChange}
              defaultValue={field.value}
              value={field.value}
            >
              <SelectTrigger id={`config-${config.code}`} className="w-full max-w-3xl bg-gray-blue-1">
                <SelectValue placeholder="Select an option" />
              </SelectTrigger>
              <SelectContent>
                {config?.selectOptions?.map((item) => (
                  <SelectItem key={item.value} value={item.value}>
                    {item.name}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
          )}
        />
      </div>
    </>
  );
};

export default ConfigSelect;
